import { createSelector } from 'reselect'

export const getMenuState = (state) => state.siderNavBar.menuVisible
export const getSidebarItems = (state) => state.siderNavBar.navItems
export const getNavBarItems = (state) => state.siderNavBar.navBaritems
export const getActiveItem = (state) => state.siderNavBar.active